<template>
  <div class="skeleton-wrapper">
    <!-- ===== TOP PICKS SKELETON ===== -->


    <!-- <div class="top-pick-skeleton">
      <div v-for="i in dummyItems" :key="'pick-' + i" class="pick-card">
        <ion-skeleton-text animated class="image"></ion-skeleton-text>

        <div class="content">
          <ion-skeleton-text animated class="name"></ion-skeleton-text>
          <div class="footer">
            <ion-skeleton-text animated class="price"></ion-skeleton-text>
            <ion-skeleton-text animated class="btn"></ion-skeleton-text>
          </div>
        </div>
      </div>
    </div> -->

    <!-- ===== OUTLET LIST SKELETON ===== -->
    <div class="outlet-section">
      <div v-for="i in outletItems" :key="'outlet-' + i" class="outlet-card">
        <ion-skeleton-text animated class="outlet-image"></ion-skeleton-text>

        <div class="outlet-info">
          <ion-skeleton-text animated class="outlet-name"></ion-skeleton-text>
          <ion-skeleton-text animated class="outlet-address"></ion-skeleton-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IonSkeletonText } from "@ionic/vue";

export default {
  name: "HomeSkeleton",
  components: { IonSkeletonText },
  data() {
    return {
      dummyItems: [1, 2, 3, 4],
      outletItems: [1, 2, 3]
    };
  }
};
</script>

<style scoped>
.skeleton-wrapper {
  padding: 8px 0;
}

/* Header */
.header-skeleton {
  margin: 12px 0 8px;
}

.title {
  width: 120px;
  height: 18px;
  border-radius: 8px;
}

.title.small {
  width: 160px;
}

/* ===== TOP PICKS ===== */
.top-pick-skeleton {
  display: flex;
  gap: 12px;
  overflow-x: auto;
}

.top-pick-skeleton::-webkit-scrollbar {
  display: none;
}

.pick-card {
  min-width: 140px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.image {
  width: 100%;
  height: 100px;
}

.content {
  padding: 10px;
}

.name {
  width: 90%;
  height: 14px;
  border-radius: 6px;
  margin-bottom: 8px;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price {
  width: 60%;
  height: 14px;
  border-radius: 6px;
}

.btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}

/* ===== OUTLET LIST ===== */
.outlet-section {
  margin-top: 20px;
}

.outlet-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 16px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
}

.outlet-image {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  flex-shrink: 0;
}

.outlet-info {
  flex: 1;
}

.outlet-name {
  width: 70%;
  height: 14px;
  border-radius: 6px;
  margin-bottom: 6px;
}

.outlet-address {
  width: 90%;
  height: 12px;
  border-radius: 6px;
}
</style>
